<template>
    <div class="ct-box">
        <div class="pay">
            <div class="selbox clearfix">
                <div class="set-meal" :class="[curMeal.guid === meal.guid ? 'current' : '']"
                     @click="selectedMeal(meal)" v-for="(meal, index) in allMeals">
                    <div class="pay-time">
                        <span>{{meal.package_name}}</span>
                    </div>
                    <div class="pay-money">
                        <span class="pay-price">{{meal.price}}<i> 元</i></span>
                        <span class="gift">&nbsp;(共{{meal.term}}天)</span>
                    </div>
                </div>
            </div>

            <div class="version">
                <div class="sel-v">
                    <div class="ch-box">
                        <button class="change-v" :class="[typeVersion === 1 ? 'current' : '']" @click="selectedVersion(1)"><span>公司版</span></button>
                        <button class="change-v" :class="[typeVersion === 2 ? 'current' : '']" @click="selectedVersion(2)"><span>集团版</span></button>
                    </div>

                    <div class="v-explain">
                        <div v-if="typeVersion === 1">
                            <h6>公司版租用说明：</h6>
                            <p style="margin-top:20px;">7天10元，90天600元，180天1180</p>
                            <p>元，360天1980元，720天2880元</p>
                            <p>送180天，1440天送360天。</p>
                        </div>

                        <div v-if="typeVersion === 2">
                            <h6>集团版租用说明：</h6>
                            <p style="margin-top:20px;">7天50元，90天1980元，180天</p>
                            <p>3880元，360天6880元，720天11880元送180天，1440天19880</p>
                            <p>元送360天。</p>
                        </div>

                    </div>

                </div>

                <div class="rule">

                </div>
                <!-- 图片 -->
                <div class="pay-pic">
                    <div class="weixin">
                        <div class="erm-wx">
                            <img @click="payMeal(1)" :src="qrCodeUrl[1]"  draggable="false" onmousedown="false" alt="微信支付">
                        </div>
                        <p>使用微信支付</p>
                    </div>
                    <div class="zfb">
                        <div class="erm-zfb">
                            <img @click="payMeal(2)" :src="qrCodeUrl[2]" draggable="false" onmousedown="false" alt="支付宝支付">
                        </div>
                        <p>支付宝支付</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import cookie from 'vue-cookie'
    export default {
        name: "PayMeal",
        beforeRouteEnter(to, from, next) {
            if(cookie.get('erp_tk') && cookie.get('erp_st')) {
                switch (cookie.get('erp_st')) {
                    case '1':
                        next({ path: '/client' })
                        break
                    case '2':
                        next({ path:'/site_config' })
                        break
                    case '4':
                        next({ path: '/build_site'})
                        break
                    default:
                        next(true)
                        break
                }
            } else {
                next({path: '/client', query: { redirect: to.fullPath }})
            }
        },
        data() {
            return {
                uiLayer: layer,
                typeVersion: 1,
                qrCodeUrl: { 1: '/apply/images/backend/paymeal/buy_code.png', 2:'/apply/images/backend/paymeal/buy_code.png'},
                apiDomain: 'http://wechat.lixun365.com',
                curMeal: {guid: '', package_name: '', term: '', price: ''},
                allMeals: [{guid: '', package_name: '', term: '', price: ''}],
                sendOptions: {ticket: '', pay_type: 1, client_id: '', site_id: '', product_id: '', body: '', total_fee: '', detail: '', amount: 1},
            }
        },
        created: function() {
            this.$axios.get(this.apiDomain + '/api/meal.meal/getmeallists')
                .then(res => {
                    if(res.data.code === 1001) {
                        this.allMeals = res.data.data
                        this.curMeal = res.data.data[0]
                        this.sendOptions.product_id = this.curMeal.guid
                        this.sendOptions.body = this.curMeal.package_name
                        this.sendOptions.total_fee = this.curMeal.price
                    } else {
                        layer.msg(res.data.code)
                    }
                }).catch(err => {console.error(err)})
            this.$axios.get(this.apiDomain + '/api/site.site/paymeal', {params: {ticket: this.$cookie.get('erp_tk')}})
                .then(res => {
                    if(res.data.code === 1001) {
                        this.sendOptions.client_id = res.data.data.client_id
                        this.sendOptions.site_id = res.data.data.site_id
                    } else {
                        layer.msg(res.data.msg)
                    }
                }).catch(err => {console.error(err)})
            this.sendOptions.ticket = this.$cookie.get('erp_tk')
        },
        mounted: function() {
            if("WebSocket" in window) {
                var ws = new WebSocket('ws://wechat.lixun365.com:9501')
                ws.onopen = function() {
                    console.log('connected!!')
                }
                ws.onmessage = this.listenPayResult(this)
                ws.onclose = function() {
                    console.log('the socket server closed!!')
                }
            } else {
                layer.msg("您的浏览器不支持WebSocket!!")
            }
        },
        methods: {
            selectedVersion: function(i) {
                this.typeVersion = i
                this.qrCodeUrl = { 1: '/apply/images/backend/paymeal/buy_code.png', 2:'/apply/images/backend/paymeal/buy_code.png'}
            },
            selectedMeal: function(m) {
                this.curMeal = m
                this.sendOptions.product_id = m.guid
                this.sendOptions.total_fee = m.price * this.sendOptions.amount
                this.sendOptions.body = m.package_name
                this.qrCodeUrl = { 1: '/apply/images/backend/paymeal/buy_code.png', 2:'/apply/images/backend/paymeal/buy_code.png'}
            },
            payMeal: function(payType) {
                this.sendOptions.pay_type = payType
                this.qrCodeUrl = { 1: '/apply/images/backend/paymeal/buy_code.png', 2:'/apply/images/backend/paymeal/buy_code.png'}
                this.$axios.post(this.apiDomain + '/api/site.site/paymeal', this.sendOptions)
                    .then(res => {
                        if(res.data.code === 1001) {
                            this.qrCodeUrl[payType] = res.data.data.qr_code_url
                        } else {
                            layer.msg(res.data.msg)
                        }
                    }).catch(err => {console.error(err)})
            },
            listenPayResult: function(self) {
                return function(e){
                    var received_msg = JSON.parse(e.data)
                    if(received_msg && received_msg.code === 1001) {
                    if(received_msg.notifed === 'SUCCESS') {
                        layer.msg('支付成功！页面加载中。。。', {shade: 0.01})
                        setTimeout(function() {
                            self.$cookie.set('erp_tk', received_msg.ticket, {expires: '7200s'})
                            self.$cookie.set('erp_st', 4, {expires: '1D'})
                            self.$router.push({name: 'buildSite'})
                        }, 1000)
                    }
                }
                }

            }
        }
    }
</script>